import { CircularLoading } from '@foxtaibox/foxtailbox-frontend-core';
import AssesmentAccessCard, { MessageVariant } from 'components/AssesmentAccessCard';
import ROUTES from 'constants/routes';
import useIsExaminationActive from 'hooks/useIsExaminationActive';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ExaminationCheck = () => {
  const navigate = useNavigate();
  const { isExaminationActive, loading, examinationId, error } = useIsExaminationActive();

  useEffect(() => {
    if (isExaminationActive === true && examinationId) {
      navigate(`${ROUTES.EXAMINATION_RECEIVE}/${examinationId}`, { replace: true });
    }
  }, [isExaminationActive]);

  if (loading || isExaminationActive === undefined) return <CircularLoading />;

  if (!isExaminationActive)
    return (
      <AssesmentAccessCard messageVariant={error ? MessageVariant.ERROR : MessageVariant.ACCESS} />
    );

  return null;
};

export default ExaminationCheck;
